import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

const getAccountIDVStatus = (state) => resolveProp('identity.accountIDVStatus', state);

export default createSelector(getAccountIDVStatus, (accountIDVStatus) => ({
    accountIDVStatus,
}));
